export const ALL_STORIES = 'allStories';
export const MY_STORIES = 'myStories';
export const IMAGE_POST = 'image';
export const BLOG_POST = 'blog';
